import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export type ButtonVariant = "default" | "hover";
export const BUTTON_VARIANT_TYPES: Record<string, ButtonVariant> = {
  default: "default",
  hover: "hover",
};

export const ButtonStateSelector = ({
  selectedButtonVariant,
  setSelectedButtonVariant,
}: {
  selectedButtonVariant: ButtonVariant;
  setSelectedButtonVariant: (variant: ButtonVariant) => void;
}) => (
  <div className="border-primary border-b px-6 py-5">
    <div className="bg-tertiary grid w-full grid-cols-2 gap-1 rounded-xl p-1">
      {Object.values(BUTTON_VARIANT_TYPES).map(variant => (
        <button
          key={variant}
          type="button"
          className={classNames("w-full rounded-lg px-2 py-1", {
            "bg-primary": selectedButtonVariant === variant,
            "bg-transparent": selectedButtonVariant !== variant,
          })}
          onClick={() => setSelectedButtonVariant(variant)}
        >
          <Typography.LabelSm weight="semibold" color="text-dark">
            {t(`builder_ui.block_type.button_variants.${variant}`)}
          </Typography.LabelSm>
        </button>
      ))}
    </div>
  </div>
);
